var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export default styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 2em;\n  margin: 0;\n  white-space: nowrap;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  font-size: 2em;\n  margin: 0;\n  white-space: nowrap;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
var templateObject_1;
